export default __webpack_public_path__ + "static/media/partner2.c5ca9ae4.jpg";